import styles from './style.module.css'

interface CustomToastProps {
  title: string
  message?: string
}

const CustomToast = ({ message, title }: CustomToastProps) => (
  <div className={styles.wrapper}>
    <strong className={styles.title}>{title}</strong>
    {message ? <span className={styles.message}>{message}</span> : null}
  </div>
)

export default CustomToast
